import React from "react";
import { CalendarDays, CheckCircle2, Clock, Layers, Receipt } from "lucide-react";

import { canalPorChave } from "@/components/canais/canais";
import IconeCanal from "@/components/canais/IconeCanal";

import { vencimentos } from "./formulario";

const reais = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const dataBR = (iso) => (iso ? iso.split("-").reverse().join("/") : "—");

function Datas({ lista, valor }) {
  if (lista.length <= 1) return null;
  const mostrar = lista.length > 8 ? [...lista.slice(0, 6), null, lista[lista.length - 1]] : lista;
  return (
    <div className="mt-4">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2 flex items-center gap-1.5">
        <CalendarDays className="w-3.5 h-3.5" />{lista.length} lançamentos · total {reais(valor * lista.length)}
      </p>
      <ul className="space-y-1 text-sm" data-e2e="resumo-vencimentos">
        {mostrar.map((iso, i) => (iso ? (
          <li key={iso + i} className="flex justify-between tabular-nums"><span className="text-muted-foreground">{dataBR(iso)}</span><span>{reais(valor)}</span></li>
        ) : <li key="reticencias" className="text-center text-muted-foreground">⋯</li>))}
      </ul>
    </div>
  );
}

function Modulos({ modulos, valor }) {
  const parte = modulos.length ? valor / modulos.length : 0;
  return (
    <div className="mt-4 pt-4 border-t">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2 flex items-center gap-1.5"><Layers className="w-3.5 h-3.5" />Módulos</p>
      {!modulos.length ? <p className="text-sm text-muted-foreground" data-e2e="resumo-sem-modulo">Sem módulo — despesa comum da loja.</p> : (
        <ul className="space-y-2" data-e2e="resumo-modulos">
          {modulos.map((k) => {
            const c = canalPorChave(k);
            return (
              <li key={k}>
                <div className="flex items-center gap-2 text-sm">
                  <IconeCanal canal={c} className="w-4 h-4" /><span className="flex-1">{c.nome}</span>
                  <span className="tabular-nums font-semibold">{reais(parte)}</span>
                </div>
                <div className="h-1.5 rounded-full bg-muted mt-1 overflow-hidden"><div className="h-full rounded-full" style={{ width: `${100 / modulos.length}%`, backgroundColor: c.hex }} /></div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

// Coluna da direita: o que vai ser gravado, conferido antes de salvar.
export default function ResumoDespesa({ form, edicao }) {
  const valor = parseFloat(form.value) || 0;
  const lista = edicao ? [form.dueDate] : vencimentos(form);
  return (
    <aside className="bg-card rounded-2xl border p-5 sm:p-6 lg:sticky lg:top-0" data-e2e="resumo-despesa">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground flex items-center gap-1.5"><Receipt className="w-3.5 h-3.5" />Resumo</p>
      <p className="text-lg font-bold mt-2 truncate">{form.name || "Nova despesa"}</p>
      <p className="text-3xl font-black tabular-nums" data-e2e="resumo-valor">{reais(valor)}</p>
      <div className="mt-2 flex flex-wrap items-center gap-2 text-sm">
        <span className="text-muted-foreground">vence {dataBR(form.dueDate)}</span>
        {form.isPaid
          ? <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-green-500/15 text-green-700 dark:text-green-400 text-xs font-semibold"><CheckCircle2 className="w-3 h-3" />Paga</span>
          : <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-700 dark:text-amber-400 text-xs font-semibold"><Clock className="w-3 h-3" />Pendente</span>}
      </div>
      <Datas lista={lista} valor={valor} />
      <Modulos modulos={form.modulos} valor={valor} />
    </aside>
  );
}
